document.addEventListener('DOMContentLoaded', function () {

  // HERO SLIDER
  const track = document.getElementById('sliderTrack');
  const dots = document.querySelectorAll('.hero-dot');
  const slides = document.querySelectorAll('.hero-slide');
  let current = 0, autoTimer;

  function goTo(n) {
    current = (n + slides.length) % slides.length;
    if (track) track.style.transform = `translateX(-${current * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle('active', i === current));
  }
  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }
  function startAuto() { autoTimer = setInterval(next, 5000); }
  function stopAuto() { clearInterval(autoTimer); }

  const btnNext = document.getElementById('heroNext');
  const btnPrev = document.getElementById('heroPrev');
  if (btnNext) btnNext.addEventListener('click', () => { stopAuto(); next(); startAuto(); });
  if (btnPrev) btnPrev.addEventListener('click', () => { stopAuto(); prev(); startAuto(); });
  dots.forEach((d, i) => d.addEventListener('click', () => { stopAuto(); goTo(i); startAuto(); }));
  startAuto();

  // PRODUCT CAROUSEL ARROWS
  document.querySelectorAll('.carousel-arrow').forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.dataset.target;
      const t = targetId ? document.getElementById(targetId) : btn.closest('.expert-videos__wrap')?.querySelector('.expert-videos__track');
      if (!t) return;
      const dir = btn.classList.contains('carousel-arrow--next') ? 1 : -1;
      t.scrollBy({ left: dir * 280, behavior: 'smooth' });
    });
  });
  const expertNext = document.querySelector('.expert-next');
  if (expertNext) {
    expertNext.addEventListener('click', () => {
      const t = document.querySelector('.expert-videos__track');
      if (t) t.scrollBy({ left: 240, behavior: 'smooth' });
    });
  }

  // MOBILE MENU
  const mobToggle = document.querySelector('.mob-toggle');
  const mobMenu = document.querySelector('.mob-menu');
  if (mobToggle && mobMenu) {
    mobToggle.addEventListener('click', () => {
      mobMenu.classList.toggle('open');
      const spans = mobToggle.querySelectorAll('span');
      if (mobMenu.classList.contains('open')) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });
    mobMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobMenu.classList.remove('open');
        mobToggle.querySelectorAll('span').forEach(s => {
          s.style.transform = '';
          s.style.opacity = '';
        });
      });
    });
  }

  // EXPERT VIDEO TABS
  const tabs = document.querySelectorAll('.expert-tab');
  const vcards = document.querySelectorAll('.video-card');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const cat = tab.dataset.cat;
      vcards.forEach(card => {
        card.style.display = (cat === 'all' || card.dataset.cat === cat) ? '' : 'none';
      });
    });
  });

  // FAQ ACCORDION
  document.querySelectorAll('.faq-q').forEach(btn => {
    const initAns = btn.nextElementSibling;
    if (initAns) initAns.style.maxHeight = '0';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.faq-q').forEach(b => {
        b.setAttribute('aria-expanded', 'false');
        const a = b.nextElementSibling;
        if (a) a.style.maxHeight = '0';
      });
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        const ans = btn.nextElementSibling;
        if (ans) ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  });

  // SCROLL REVEAL
  if ('IntersectionObserver' in window) {
    const revealEls = document.querySelectorAll(
      '.prod-card, .rev-card, .ing-row, .video-card, .story-block, .step, .hiw-step, .faq-item, .ing-icon, .quality-card, .cert-card, .ing-card'
    );
    revealEls.forEach(el => el.classList.add('reveal'));
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    revealEls.forEach(el => obs.observe(el));
  }

  // STICKY HEADER
  const hdr = document.querySelector('.site-hdr');
  if (hdr) {
    window.addEventListener('scroll', () => {
      hdr.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

});
